// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__22Eox","paramInput":"JobSimulator_paramInput__3Vd1X","input":"JobSimulator_input__1dHSZ"};